import Chip from '@mui/material/Chip';
import { Body2 } from '../../themes/typography';

const styles = {
    showingResultTags: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        height: '100%'
    }
};

export function SearchResultChip({
    chipName = 'Default Chip',
    onDelete = () => { },
    onClick = () => { },
    // disabled = false
}) {
    return (
        <Chip
            label={<Body2 color="var(--primary-color)">{chipName}</Body2>}
            variant="soft"
            onDelete={onDelete}
            onClick={onClick}
            classes={{
                root: 'css-wgqphw-MuiButtonBase-root-MuiChip-root',
                deleteIcon: 'css-wgqphw-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon',
                label: 'css-6od3lo-MuiChip-label'
            }}
            sx={{
                backgroundColor: 'var(--secondary-color)',
                height: '32px',
                '&.css-wgqphw-MuiButtonBase-root-MuiChip-root': {
                    backgroundColor: 'var(--secondary-color)',
                    color: 'white',
                    width: 'auto',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '5px 10px'
                },
                '& .MuiChip-deleteIcon': {
                    width: 'auto',
                    color: 'var(--primary-color)',
                    fontSize: '1.175rem',
                    margin: '0px',
                    borderRadius: '50%',
                    transition: 'all 0.2s',
                    // pointerEvents: disabled ? 'none' : 'auto',
                    // cursor: disabled ? 'not-allowed' : 'pointer'
                },
                '& .MuiChip-deleteIcon: hover': {
                    color: 'white'
                },
                '& .css-6od3lo-MuiChip-label': {
                    color: 'var(--primary-color)',
                    padding: '0px',
                    margin: '0px'
                }
            }}
        />
    );
}

export default function SearchResult({ selectChip, onDelete = () => { } }) {
    return (
        <div style={styles.showingResultTags}>
            {selectChip.map((chip) => (
                <SearchResultChip
                    key={chip.id}
                    chipName={chip.name}
                    onDelete={() => onDelete(chip)}
                />
            ))}
        </div>
    );
}

// Use this component like this when reused in other components

// const initialChips = [
//     { id: 1, name: 'Business' },
//     { id: 2, name: 'Art' },
//     { id: 3, name: 'Music' }
// ];

// return (
//     <div>
//         <SearchResult initialChips={initialChips} />
//     </div>
// );
